
import { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { authService } from '../../../services';
import { SEARCH_QUERY } from '../../queries/SEARCH_QUERY';
import { useAuthState } from '../../../hooks/auth';
import { useTranslations } from '../../../hooks/translations';

export function useCategoryListQuery( options ) {

    const { claims } = useAuthState();
    const { locale } = useTranslations();

    const {
        data: categoriesResponse,
        loading: categoriesLoading
    } = useQuery( SEARCH_QUERY, { 
        ...options, 
        variables: { 
            types: [ 'categories' ], 
            sort: 'weight', 
            order: 'asc', 
            page: 1,
            limit: 100,
            personId: authService.isAdminUser() ? undefined : claims.person_id,  
        } 
    } );

    const categoryData = useMemo( () => {
        if ( categoriesLoading ) {return [];}

        return categoriesResponse?.search?.edges?.map( e => e.node ).map( formatCategory ) ?? [];
    }, [ categoriesLoading ] );

    function formatCategory( c ) {
        return {
            ...c,
            id: c.categoryId,
            name: ( c.name.find( n => n.locale == locale ) ?? c.name.find( n => n.locale == 'en-US' ) ?? c.name[ 0 ] )?.content,
            description: ( c.description.find( n => n.locale == locale ) ?? c.description.find( n => n.locale == 'en-US' ) ?? c.description[ 0 ] )?.content,
        };
    }


    return useMemo ( () => ( {
        data: categoryData,
        loading: categoriesLoading
    } ), [ categoryData ] );
}
